import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { loginRequest, logout } from '../actions/authentication';
import AppDrawer from '../components/drawer';
import { withDefaultStyles } from '../utils/material-ui/hoc';
import Login from './login';

class MainDrawer extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Login />
        <AppDrawer
            onSignin={this.handleSignInRequest}
            onSignout={this.handleSignOutRequest}
            onConsole={this.navToConsole}
            onMain={this.navToMain}
            onTenants={this.navToTenants}
            selectedMenu={this.props.selectedMenu}
          >
          {this.props.children}
        </AppDrawer>
      </div>
    );
  }

  private handleSignInRequest = () => this.props.dispatch(loginRequest())
  private handleSignOutRequest = () => this.props.dispatch(logout())

  private navToMain = () => this.props.history.push('/')
  private navToConsole = () => this.props.history.push('/console')
  private navToTenants = () => this.props.history.push('/console/tenants')
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(MainDrawer)));



// WEBPACK FOOTER //
// ./src/containers/main-drawer.tsx